module.exports = __webpack_public_path__ + "img/home.7026a176.png";